import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";

function DialogAlert({ open, handleClose, title, message }) {
  return (
    <>
      <Dialog open={open} onClose={() => handleClose(false)}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <>{message}</ >
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(false)} color="primary">
            Non
          </Button>
          <Button onClick={() => handleClose(true)} color="primary">
            Oui
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default DialogAlert;
